import React, { useEffect, useState } from 'react';
import Layout from '../templates/DefaultLayout';
import TitleForm from './TitleForm';
import TryonExpressHelp from './TryonExpressHelp';
import { resourceDocumentApi, document } from '~/api';
import { Portal } from '~/components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

const ResourcesPage = () => {
    const [titleFormData, setTitleFormData] = useState([]);
    const [tryonExpressHelpData, setTryonExpressHelpData] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        const fetchData = async() => {
            if(mounted) {
                const resourcesData = await resourceDocumentApi.getResourceDocuments();
                
                const titleFormData = resourcesData && resourcesData.filter((x) => x.typeId == document.DocumentType.TITLE_FORM).map((x) => {
                    return {
                        description: x.Description,
                        documentId: x.id
                    };
                });
                const tryonExpressHelpData = resourcesData && resourcesData.filter((x) => x.typeId == document.DocumentType.TRYON_EXPRESS_HELP_DOCUMENT).map((x) => {
                    return {
                        description: x.Description,
                        documentId: x.id
                    };
                });
                setTitleFormData(titleFormData); 
                setTryonExpressHelpData(tryonExpressHelpData);
                setLoading(false);
            }
        };
        fetchData();
        return () => mounted = false;
    }, []); 

    return (
        <Layout title="Resources" subtitle="">
            <div className="container flex flex-col py-4">
                {isLoading &&
                <Portal id="loading-modal">
                    <div className="flex items-center justify-center h-screen w-screen bg-gray-400 opacity-70 z-50 fixed top-0 left-0 translate-y-1/2 -translate-x-1/2">
                        <AiOutlineLoading3Quarters className="animate-spin text-blue-30 font-bold" size="4rem" />
                    </div>
                </Portal>
                }
                {!isLoading &&
                <>
                    <TitleForm titleFormData={titleFormData}></TitleForm>
                    <TryonExpressHelp tryonExpressHelpData={tryonExpressHelpData}></TryonExpressHelp>
                </>
                }
            </div>
        </Layout>
    );
};

export default ResourcesPage;